import { render, staticRenderFns } from "./BookingBadge.vue?vue&type=template&id=3fe55d4a&scoped=true"
import script from "./BookingBadge.vue?vue&type=script&lang=ts"
export * from "./BookingBadge.vue?vue&type=script&lang=ts"
import style0 from "./BookingBadge.vue?vue&type=style&index=0&id=3fe55d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe55d4a",
  null
  
)

export default component.exports